(function(){
  // Mobile menu
  var openBtn=document.querySelector('[data-open-menu]');
  var menu=document.getElementById('MobileMenu');
  if(openBtn&&menu){
    openBtn.addEventListener('click',function(){menu.classList.add('open');});
    menu.querySelectorAll('[data-close-menu],a').forEach(function(el){
      el.addEventListener('click',function(){menu.classList.remove('open');});
    });
  }

  // Announcement rotator
  var msgs=document.querySelectorAll('.announcement .msg');
  if(msgs.length>1){var i=0;setInterval(function(){msgs[i].classList.remove('show');i=(i+1)%msgs.length;msgs[i].classList.add('show');},3800);}

  // Toast
  var toast;
  function showToast(text){
    if(!toast){toast=document.createElement('div');toast.className='toast';document.body.appendChild(toast);}
    toast.textContent=text;toast.classList.add('show');
    clearTimeout(showToast._t);showToast._t=setTimeout(function(){toast.classList.remove('show');},2200);
  }

  function updateCartCount(){
    fetch('/cart.js').then(function(r){return r.json();}).then(function(c){
      document.querySelectorAll('[data-cart-count]').forEach(function(el){el.textContent=c.item_count;});
    });
  }

  // AJAX add to cart for any form with data-ajax-add
   // Add to cart: fly-to-cart animation, then go to cart page
  document.addEventListener('submit',function(e){
    var form=e.target.closest('form[data-ajax-add]');
    if(!form)return;
    e.preventDefault();
    var btn=form.querySelector('[type="submit"]');
    if(btn){btn.disabled=true;}

    // Find the product image in the same card to animate
    var card=form.closest('.pcard')||form.closest('.product');
    var img=card?card.querySelector('img'):null;
    var cartIcon=document.querySelector('.header-actions a[href*="cart"] svg, .header-actions a[aria-label="Cart"]');

    if(img&&cartIcon){
      var iRect=img.getBoundingClientRect();
      var cRect=cartIcon.getBoundingClientRect();
      var fly=img.cloneNode(true);
      fly.style.cssText='position:fixed;z-index:2000;left:'+iRect.left+'px;top:'+iRect.top+'px;width:'+iRect.width+'px;height:'+iRect.height+'px;object-fit:contain;border-radius:12px;pointer-events:none;transition:all .7s cubic-bezier(.5,-0.3,.7,1);opacity:.95';
      document.body.appendChild(fly);
      requestAnimationFrame(function(){
        fly.style.left=cRect.left+'px';
        fly.style.top=cRect.top+'px';
        fly.style.width='30px';
        fly.style.height='30px';
        fly.style.opacity='.2';
      });
      setTimeout(function(){if(fly.parentNode)fly.parentNode.removeChild(fly);},750);
    }

    // Add to cart, then redirect to the cart page
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:form.querySelector('[name="id"]').value,quantity:(form.querySelector('[name="quantity"]')||{}).value||1}]})})
      .then(function(r){return r.json();})
      .then(function(){
        setTimeout(function(){ window.location.href='/cart'; }, 720);
      })
      .catch(function(){ form.submit(); });
  });

  // Product gallery thumbnails
  document.querySelectorAll('[data-thumb]').forEach(function(t){
    t.addEventListener('click',function(){
      var main=document.querySelector('[data-gallery-main]');
      if(main){main.src=t.getAttribute('data-full');}
    });
  });

  // WhatsApp "Message us" bubble
  var bubble=document.getElementById('waBubble');
  var fab=document.querySelector('.whatsapp-fab');
  if(bubble){
    setTimeout(function(){bubble.classList.add('show');},2500);
    bubble.addEventListener('click',function(e){
      if(e.target.hasAttribute('data-wa-close')){e.stopPropagation();bubble.classList.remove('show');return;}
      if(fab) fab.click();
    });
  }
    // Reveal trust badges on scroll
  var trustItems=document.querySelectorAll('.trust-item');
  if(trustItems.length && 'IntersectionObserver' in window){
    var obs=new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('in-view'); obs.unobserve(en.target); } });
    },{threshold:.2});
    trustItems.forEach(function(el){ obs.observe(el); });
  } else {
    trustItems.forEach(function(el){ el.classList.add('in-view'); });
  }
})();